<template >
  <div style="width: 100%; height: 100%; text-align: center;">
    
    <img v-if="lan == 'tw'" src="/img/avatars/logo_tw_305x154.png" style="width: 188px; height: 150px;"/>    
    <img v-if="lan == 'zh'" src="/img/avatars/logo_cn_305x154.png" style="width: 188px; height: 150px;"/>
    <img v-if="lan == 'jp'" src="/img/avatars/logo_tw_305x154.png" style="width: 188px; height: 150px;"/>
    <img v-if="lan == 'en'" src="/img/avatars/logo_en_305x154.png" style="width: 188px; height: 150px;"/>
    <br/>
    <img v-if="lan == 'tw'" src="/img/avatars/barcode_zh.png" class="responsive-barcode"/>
    <img v-if="lan == 'zh'" src="/img/avatars/barcode_zh.png" class="responsive-barcode"/>
    <img v-if="lan == 'jp'" src="/img/avatars/barcode_zh.png" class="responsive-barcode"/>
    <img v-if="lan == 'en'" src="/img/avatars/barcode_en.png" class="responsive-barcode"/>
    <br/>
    <br/>
    <div style="text-align: center; color: white; font-size: 20px;">{{ place }}</div>
    <br/>
    <input class="responsive-textbox" type="text" maxlength="16" :placeholder="place" v-model="barcode" @keyup.enter="getLabel()">
    <br/>
    <br/>
    <input type="button" style="height: 40px;" class="responsive-textbox" value="顯示訊息" @click="getLabel()">
    <ejs-toast ref='toastRef' id='toast_type' :position='position'></ejs-toast>     
  </div>   
</template>

<script lang="ts">

import Vue from "vue";
import Loading from 'vue-loading-overlay';
import { ToastComponent } from "@syncfusion/ej2-vue-notifications";
import { setCulture, enableRipple } from '@syncfusion/ej2-base';
import { DialogPlugin, TooltipPlugin } from '@syncfusion/ej2-vue-popups';


setCulture('en-US');


enableRipple(true);
Vue.use(DialogPlugin);
Vue.use(TooltipPlugin);
Vue.use(Loading);

let Loader      = undefined;

export default {
  name: 'Department',
  components: {   
    'ejs-toast': ToastComponent,

  },
  data: function () {
    return {
      data: null,
      barcode: '', lan: 'en', place: 'Please enter the 16-digit Label ID numbers beneath the QR Code',
      position: { X: 'Right', Y: "Bottom" },
    };
  },
  methods: {    
    getLabel: function () {
      this.showLoading();
      this.axios({
          method: 'post',
          baseURL: Vue.prototype.GLOBAL.baseURL,
          url: `App/WebSearch`,
          headers: {'Content-Type' : 'application/json'},
          data: { no: this.barcode, lan: this.lan }
      })
      .then((response) => {       
        this.hideLoading();   
        if (!response.data.ok) { this.$refs.toastRef.show( { title: '錯誤!', content: response.data.msg, cssClass: 'e-toast-danger', icon: 'e-warning toast-icons' }); return; }              
        console.log(response.data.datas);
        this.$store.commit('setbarcode', response.data.datas)
        this.$router.push({
          path: '/pages/websearch2'       
        })
      })
      .catch((error) => { this.showError(error, true) }
      ) 
      
    },
    showError: function (error) {     
      this.hideLoading();
      if (error.response.status == 400) {
        for(var key in error.response.data.errors){      
          this.$refs.toastRef.show( { title: '警告!', content: error.response.data.errors[key][0] , cssClass: 'e-toast-warning', icon: 'e-warning toast-icons' });           
        }
        return;
      }         
      this.$refs.toastRef.show( { title: '錯誤!', content: error.response.status, cssClass: 'e-toast-danger', icon: 'e-warning toast-icons' });
    },
    showMsg: function (msg) {      
      this.$refs.toastRef.show( { title: '訊息!', content: msg, cssClass: 'e-toast-info', icon: 'e-info toast-icons' });
    },
    showLoading() {
      Loader = this.$loading.show({
        container: this.$refs.loadingContainer,
        canCancel: true, // default false
        onCancel: this.yourCallbackMethod,
        color: 'blue',
        loader: 'bars',  // spinner, dots, bars
        width: 164,
        height: 164,
        backgroundColor: 'black',
        opacity: 0.5,
        zIndex: 999,
      });
    },
    hideLoading() {
        Loader.hide();
    }
  },
  created() {
    if (this.$route.query.id != undefined) {
      this.barcode = this.$route.query.id;
    }
    if (this.$route.query.lan != undefined) {
      this.lan = this.$route.query.lan.toLowerCase();
      if (this.lan != 'tw' && this.lan != 'zh' && this.lan != 'jp' && this.lan != 'en') {
        this.lan = 'en';
      }
    }
    if (this.lan == 'tw') {
      this.place = '請輸入條碼下方16位標籤序號';
    } else if (this.lan == 'zh') {
      this.place = '请输入条码下方16位标签序号';
    } else if (this.lan == 'jp') {
      this.place = 'QRコードの下の16桁の数字を入力してください。';    
    } else if (this.lan == 'th') {
      this.place = 'กรุณากรอกรหัส 16 หลักใต้ QR Code';
    } else {
      this.place = 'Please enter the 16-digit Label ID numbers beneath the QR Code';
    }
  },
  mounted() {
  },
  beforeUpdate() {
  },
  beforeDestroy() {
  }
}
</script>
<style>

html, body, #app {
  height: 100%;
  margin: 0;
  background-image: url('/img/avatars/web_1024x768.png');
  background-size: cover;
}

/* 預設情況（大螢幕） */
.responsive-barcode {
  width: 600px;
  height: auto; /* 確保高度依比例縮放，不會變形 */
}

/* 當螢幕寬度小於 768px 時（平板與手機） */
@media (max-width: 768px) {
  .responsive-barcode {
    padding-right: 10px;
    padding-left: 10px;
    width: 100%;
  }
}


/* 預設情況（大螢幕） */
.responsive-textbox {
  width: 600px;
  height: auto; /* 確保高度依比例縮放，不會變形 */
  border: 1px solid #ccc; 
  padding: 8px; 
  border-radius: 4px;

}

/* 當螢幕寬度小於 768px 時（平板與手機） */
@media (max-width: 768px) {
  .responsive-textbox {
    padding-right: 10px;
    padding-left: 10px;
    width: 100%;
    border: 1px solid #ccc; 
    padding: 8px; 
    border-radius: 4px;
  }
}


</style>

<style lang="scss" src="../../scss/base.scss"></style>
